<label class="__upload-button-container">
  <input type="file"
         style="display: none;"
         accept="image/png, image/jpeg, image/jpg"
         multiple="false"
         (click)="onClick($event, hasDeviceMarkers)"
         (change)="onFileUpload($event)"/>
  <ng-content></ng-content>
</label>
